import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=358136a6&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=ts"
export * from "./DeleteUserModal.vue?vue&type=script&lang=ts"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=358136a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358136a6",
  null
  
)

export default component.exports